export default __webpack_public_path__ + "static/media/dopes3.335fe7f4.jfif";